import { useState, useRef, useEffect } from "react";

// ── AIRPORT DATA ──────────────────────────────────────────────────────────────
const AIRPORTS_FALLBACK = [
  { code: "ORD", city: "Chicago", name: "O'Hare International", country: "US" },
  { code: "MDW", city: "Chicago", name: "Midway International", country: "US" },
  { code: "JFK", city: "New York", name: "John F. Kennedy International", country: "US" },
  { code: "LGA", city: "New York", name: "LaGuardia", country: "US" },
  { code: "EWR", city: "Newark", name: "Newark Liberty International", country: "US" },
  { code: "LAX", city: "Los Angeles", name: "Los Angeles International", country: "US" },
  { code: "SFO", city: "San Francisco", name: "San Francisco International", country: "US" },
  { code: "MIA", city: "Miami", name: "Miami International", country: "US" },
  { code: "ATL", city: "Atlanta", name: "Hartsfield-Jackson Atlanta International", country: "US" },
  { code: "DFW", city: "Dallas", name: "Dallas/Fort Worth International", country: "US" },
  { code: "DEN", city: "Denver", name: "Denver International", country: "US" },
  { code: "SEA", city: "Seattle", name: "Seattle-Tacoma International", country: "US" },
  { code: "LAS", city: "Las Vegas", name: "Harry Reid International", country: "US" },
  { code: "BOS", city: "Boston", name: "Logan International", country: "US" },
  { code: "IAD", city: "Washington DC", name: "Dulles International", country: "US" },
  { code: "DCA", city: "Washington DC", name: "Reagan National", country: "US" },
  { code: "PHX", city: "Phoenix", name: "Phoenix Sky Harbor International", country: "US" },
  { code: "MCO", city: "Orlando", name: "Orlando International", country: "US" },
  { code: "MSP", city: "Minneapolis", name: "Minneapolis-Saint Paul International", country: "US" },
  { code: "DTW", city: "Detroit", name: "Detroit Metropolitan Wayne County", country: "US" },
  { code: "LHR", city: "London", name: "Heathrow", country: "UK" },
  { code: "LGW", city: "London", name: "Gatwick", country: "UK" },
  { code: "STN", city: "London", name: "Stansted", country: "UK" },
  { code: "CDG", city: "Paris", name: "Charles de Gaulle", country: "France" },
  { code: "ORY", city: "Paris", name: "Orly", country: "France" },
  { code: "FRA", city: "Frankfurt", name: "Frankfurt Airport", country: "Germany" },
  { code: "MUC", city: "Munich", name: "Munich Airport", country: "Germany" },
  { code: "AMS", city: "Amsterdam", name: "Amsterdam Schiphol", country: "Netherlands" },
  { code: "MAD", city: "Madrid", name: "Adolfo Suárez Madrid-Barajas", country: "Spain" },
  { code: "BCN", city: "Barcelona", name: "Barcelona El Prat", country: "Spain" },
  { code: "FCO", city: "Rome", name: "Leonardo da Vinci International", country: "Italy" },
  { code: "MXP", city: "Milan", name: "Malpensa", country: "Italy" },
  { code: "IST", city: "Istanbul", name: "Istanbul Airport", country: "Turkey" },
  { code: "DXB", city: "Dubai", name: "Dubai International", country: "UAE" },
  { code: "AUH", city: "Abu Dhabi", name: "Zayed International", country: "UAE" },
  { code: "DOH", city: "Doha", name: "Hamad International", country: "Qatar" },
  { code: "SIN", city: "Singapore", name: "Changi Airport", country: "Singapore" },
  { code: "HKG", city: "Hong Kong", name: "Hong Kong International", country: "China" },
  { code: "NRT", city: "Tokyo", name: "Narita International", country: "Japan" },
  { code: "HND", city: "Tokyo", name: "Haneda Airport", country: "Japan" },
  { code: "ICN", city: "Seoul", name: "Incheon International", country: "South Korea" },
  { code: "BKK", city: "Bangkok", name: "Suvarnabhumi Airport", country: "Thailand" },
  { code: "KUL", city: "Kuala Lumpur", name: "Kuala Lumpur International", country: "Malaysia" },
  { code: "DEL", city: "New Delhi", name: "Indira Gandhi International", country: "India" },
  { code: "BOM", city: "Mumbai", name: "Chhatrapati Shivaji Maharaj International", country: "India" },
  { code: "BLR", city: "Bangalore", name: "Kempegowda International", country: "India" },
  { code: "MAA", city: "Chennai", name: "Chennai International", country: "India" },
  { code: "HYD", city: "Hyderabad", name: "Rajiv Gandhi International", country: "India" },
  { code: "TRV", city: "Thiruvananthapuram", name: "Trivandrum International", country: "India" },
  { code: "COK", city: "Kochi", name: "Cochin International", country: "India" },
  { code: "CCU", city: "Kolkata", name: "Netaji Subhas Chandra Bose International", country: "India" },
  { code: "AMD", city: "Ahmedabad", name: "Sardar Vallabhbhai Patel International", country: "India" },
  { code: "PNQ", city: "Pune", name: "Pune Airport", country: "India" },
  { code: "GOI", city: "Goa", name: "Goa International Airport", country: "India" },
  { code: "YYZ", city: "Toronto", name: "Pearson International", country: "Canada" },
  { code: "YVR", city: "Vancouver", name: "Vancouver International", country: "Canada" },
  { code: "YUL", city: "Montreal", name: "Montréal-Trudeau International", country: "Canada" },
  { code: "MEX", city: "Mexico City", name: "Benito Juárez International", country: "Mexico" },
  { code: "CUN", city: "Cancún", name: "Cancún International", country: "Mexico" },
  { code: "GRU", city: "São Paulo", name: "Guarulhos International", country: "Brazil" },
  { code: "GIG", city: "Rio de Janeiro", name: "Galeão International", country: "Brazil" },
  { code: "SYD", city: "Sydney", name: "Kingsford Smith International", country: "Australia" },
  { code: "MEL", city: "Melbourne", name: "Melbourne Airport", country: "Australia" },
  { code: "JNB", city: "Johannesburg", name: "O.R. Tambo International", country: "South Africa" },
  { code: "CAI", city: "Cairo", name: "Cairo International", country: "Egypt" },
  { code: "CMN", city: "Casablanca", name: "Mohammed V International", country: "Morocco" },
  { code: "NBO", city: "Nairobi", name: "Jomo Kenyatta International", country: "Kenya" },
];

let _allAirports = null;
let _loadPromise = null;

async function loadAirports() {
  if (_allAirports) return _allAirports;
  if (_loadPromise) return _loadPromise;
  _loadPromise = fetch(
    "https://raw.githubusercontent.com/jpatokal/openflights/master/data/airports.dat",
    { cache: "force-cache" }
  ).then(r => r.text()).then(text => {
    const result = [];
    for (const line of text.split("\n")) {
      try {
        const cols = [];
        let cur = "", inQ = false;
        for (const ch of line) {
          if (ch === '"') { inQ = !inQ; }
          else if (ch === ',' && !inQ) { cols.push(cur); cur = ""; }
          else { cur += ch; }
        }
        cols.push(cur);
        const iata = cols[4]?.trim();
        if (!iata || iata === "\\N" || iata.length !== 3 || !/^[A-Z]{3}$/.test(iata)) continue;
        result.push({ code: iata, name: cols[1]?.trim() || "", city: cols[2]?.trim() || "", country: cols[3]?.trim() || "" });
      } catch { continue; }
    }
    _allAirports = result;
    return result;
  }).catch(() => AIRPORTS_FALLBACK);
  return _loadPromise;
}

function searchAirports(list, q) {
  if (!q || q.length < 2) return [];
  const ql = q.toLowerCase().trim();
  return list
    .map(a => {
      let score = 0;
      if (a.code.toLowerCase() === ql) score = 100;
      else if (a.code.toLowerCase().startsWith(ql)) score = 60;
      else if (a.city.toLowerCase().startsWith(ql)) score = 40;
      else if (a.city.toLowerCase().includes(ql)) score = 20;
      else if (a.name.toLowerCase().includes(ql)) score = 10;
      else if (a.country.toLowerCase().includes(ql)) score = 5;
      return score > 0 ? { ...a, score } : null;
    })
    .filter(Boolean)
    .sort((a, b) => b.score - a.score)
    .slice(0, 7);
}

// ── AIRPORT INPUT ─────────────────────────────────────────────────────────────
function AirportInput({ label, placeholder, onChange }) {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [airports, setAirports] = useState(AIRPORTS_FALLBACK);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => { loadAirports().then(list => setAirports(list)); }, []);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const onInput = (e) => {
    const v = e.target.value;
    setQuery(v); setSelected(null); onChange("");
    if (v.length >= 2) {
      const s = searchAirports(airports, v);
      setSuggestions(s); setOpen(s.length > 0);
    } else { setSuggestions([]); setOpen(false); }
  };

  const onSelect = (a) => {
    setQuery(`${a.city} (${a.code})`);
    setSelected(a); setSuggestions([]); setOpen(false);
    onChange(a.code);
  };

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <label style={{ fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block", textTransform: "uppercase", letterSpacing: 0.5 }}>{label}</label>
      <div style={{ position: "relative" }}>
        <span style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", fontSize: 14, pointerEvents: "none" }}>✈️</span>
        <input value={query} onChange={onInput} onFocus={() => suggestions.length > 0 && setOpen(true)} placeholder={placeholder}
          style={{ width: "100%", padding: "10px 12px 10px 34px", borderRadius: 10, border: `1.5px solid ${selected ? "#2563eb" : "#e5e7eb"}`, fontSize: 14, outline: "none", boxSizing: "border-box", background: selected ? "#eff6ff" : "#fff" }} />
        {selected && <span style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", fontSize: 11, fontWeight: 700, color: "#1d4ed8", background: "#dbeafe", padding: "2px 7px", borderRadius: 4 }}>{selected.code}</span>}
      </div>
      {open && suggestions.length > 0 && (
        <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, zIndex: 200, background: "#fff", border: "1.5px solid #e2e8f0", borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,0.12)", overflow: "hidden" }}>
          {suggestions.map((a, i) => (
            <div key={a.code} onMouseDown={() => onSelect(a)}
              style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", cursor: "pointer", borderBottom: i < suggestions.length - 1 ? "1px solid #f1f5f9" : "none" }}
              onMouseEnter={e => e.currentTarget.style.background = "#eff6ff"}
              onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
              <div style={{ width: 36, height: 36, borderRadius: 8, background: "#1d4ed8", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 800, flexShrink: 0 }}>{a.code}</div>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600 }}>{a.city}</div>
                <div style={{ fontSize: 11, color: "#6b7280" }}>{a.name} · {a.country}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── DEEP LINK BUILDERS ────────────────────────────────────────────────────────
function skyscannerFlights({ origin, destination, departDate, returnDate, adults, children, infants, cabinClass }) {
  const d1 = departDate.replace(/-/g, "");
  const d2 = returnDate ? returnDate.replace(/-/g, "") : null;
  const cabin = cabinClass === "Economy" ? "economy" : cabinClass === "Premium Economy" ? "premiumeconomy" : cabinClass === "Business" ? "business" : "first";
  const base = d2
    ? `https://www.skyscanner.com/transport/flights/${origin}/${destination}/${d1}/${d2}/`
    : `https://www.skyscanner.com/transport/flights/${origin}/${destination}/${d1}/`;
  return `${base}?adultsv2=${adults}&childrenv2=${children}&infants=${infants}&cabinclass=${cabin}&rtn=${d2 ? 1 : 0}`;
}

function kayakFlights({ origin, destination, departDate, returnDate, adults, children, infants, cabinClass }) {
  const route = returnDate
    ? `${origin}-${destination}/${departDate}/${destination}-${origin}/${returnDate}`
    : `${origin}-${destination}/${departDate}`;
  const pax = `${adults}adults${children > 0 ? `-${children}children` : ""}${infants > 0 ? `-${infants}infants` : ""}`;
  return `https://www.kayak.com/flights/${route}/${pax}`;
}

function expediaFlights({ origin, destination, departDate, returnDate, adults, children, cabinClass }) {
  const trip = returnDate ? "roundtrip" : "oneway";
  let url = `https://www.expedia.com/Flights-Search?mode=search&trip=${trip}&leg1=from%3A${origin}%2Cto%3A${destination}%2Cdeparture%3A${departDate}TANYT&adults=${adults}`;
  if (children > 0) url += `&children=${children}`;
  if (returnDate) url += `&leg2=from%3A${destination}%2Cto%3A${origin}%2Cdeparture%3A${returnDate}TANYT`;
  return url;
}

function googleHotels({ location, checkin, checkout, guests }) {
  return `https://www.google.com/travel/hotels/${encodeURIComponent(location)}?checkin=${checkin}&checkout=${checkout}&guests=${guests}&hl=en`;
}
function bookingCom({ location, checkin, checkout, guests, rooms }) {
  return `https://www.booking.com/searchresults.html?ss=${encodeURIComponent(location)}&checkin=${checkin}&checkout=${checkout}&group_adults=${guests}&no_rooms=${rooms}&lang=en-us`;
}
function expediaHotels({ location, checkin, checkout, guests, rooms }) {
  return `https://www.expedia.com/Hotel-Search?destination=${encodeURIComponent(location)}&startDate=${checkin}&endDate=${checkout}&adults=${guests}&rooms=${rooms}`;
}
function kayakCars({ pickupLocation, pickupDate, dropoffDate }) {
  return `https://www.kayak.com/cars/${encodeURIComponent(pickupLocation)}/${pickupDate}/${dropoffDate}`;
}
function expediaCars({ pickupLocation, pickupDate, dropoffDate }) {
  return `https://www.expedia.com/carsearch?locn=${encodeURIComponent(pickupLocation)}&d1=${pickupDate}&d2=${dropoffDate}`;
}
function rentalcars({ pickupLocation, pickupDate, dropoffDate }) {
  return `https://www.rentalcars.com/SearchResults.do?pickUpLocation=${encodeURIComponent(pickupLocation)}&pickUpDate=${pickupDate}&dropOffDate=${dropoffDate}`;
}

// ── AI PROMPTS ────────────────────────────────────────────────────────────────
function flightPrompt({ origin, destination, departDate, returnDate, adults, children, infants, cabinClass }) {
  const trip = returnDate ? "round-trip" : "one-way";
  const totalPax = adults + children + infants;
  const paxDesc = `${adults} adult${adults > 1 ? "s" : ""}${children > 0 ? `, ${children} child${children > 1 ? "ren" : ""} (age 2-11)` : ""}${infants > 0 ? `, ${infants} infant${infants > 1 ? "s" : ""} (under 2)` : ""}`;
  return `Return ONLY a raw JSON object (no markdown) for 5 realistic ${trip} flight options.
Route: ${origin} → ${destination}
Depart: ${departDate}${returnDate ? `, Return: ${returnDate}` : ""}
Passengers: ${paxDesc} (${totalPax} total)
Cabin: ${cabinClass}

Schema: {"results":[{"airline":"","flight_number":"","departure_time":"08:15","arrival_time":"22:30","duration":"14h 15m","stops":1,"stop_cities":["Dubai"],"price_per_adult":0,"total_price":0,"cabin_class":"Economy","includes_baggage":true,"baggage_fee":0,"refundable":false,"deal_score":"good","deal_label":"Best value","on_time_rate":87,"aircraft":"Boeing 777"}]}

Rules:
- departure_time and arrival_time MUST be short format like "08:15" or "14:30" — never ISO format
- Use REAL airlines for this route (Emirates, Air India, United, Delta, etc.)
- Realistic prices for ${cabinClass} on this route
- total_price includes all ${totalPax} passengers
- price_per_adult is per adult only
- deal_score: "best" for lowest price, "good" for middle, "fair" for higher
- Vary stops: some nonstop (if route allows), some 1-stop with realistic layover cities
- on_time_rate: realistic percentage 72-94`;
}

function hotelPrompt({ location, checkin, checkout, guests, rooms, starRating }) {
  const nights = Math.max(1, Math.ceil((new Date(checkout) - new Date(checkin)) / 86400000));
  return `Return ONLY a raw JSON object (no markdown) for 5 realistic hotel options.
Location: ${location}
Dates: ${checkin} to ${checkout} (${nights} nights)
Guests: ${guests}, Rooms: ${rooms}${starRating ? `, Min stars: ${starRating}` : ""}

Schema: {"results":[{"name":"","stars":4,"neighborhood":"","price_per_night":0,"total_price":0,"rating":8.5,"review_count":1200,"review_label":"Superb","amenities":["Free WiFi","Pool","Gym"],"room_type":"Deluxe King","cancellation":"Free cancellation","deal_score":"good","deal_label":"Best value","distance_to_center":"0.5 km","highlights":["Rooftop pool","City views"]}]}

Rules:
- Use REAL hotel brands (Marriott, Hilton, Hyatt, Sheraton, boutique hotels etc.)
- total_price = price_per_night × ${nights} × ${rooms}
- deal_score: "best" for lowest, "good" for middle, "fair" for higher
- Realistic prices for ${location}`;
}

function carPrompt({ pickupLocation, pickupDate, dropoffDate, carType }) {
  const days = Math.max(1, Math.ceil((new Date(dropoffDate) - new Date(pickupDate)) / 86400000));
  return `Return ONLY a raw JSON object (no markdown) for 5 realistic car rental options.
Pickup: ${pickupLocation}
Dates: ${pickupDate} to ${dropoffDate} (${days} days)${carType ? `\nPreferred type: ${carType}` : ""}

Schema: {"results":[{"company":"Enterprise","car_name":"Toyota Corolla or similar","car_class":"Economy","seats":5,"transmission":"Automatic","price_per_day":0,"total_price":0,"mileage":"Unlimited","includes_insurance":false,"insurance_per_day":15,"free_cancellation":true,"airport_pickup":true,"deal_score":"good","deal_label":"Lowest price","rating":8.2,"review_count":340,"features":["Bluetooth","Backup camera"]}]}

Rules:
- Use REAL rental companies (Enterprise, Hertz, Avis, Budget, National, Alamo, Sixt)
- total_price = price_per_day × ${days}
- deal_score: "best" for lowest, "good" for middle, "fair" for higher`;
}

// ── API CALL ──────────────────────────────────────────────────────────────────
async function callAgent(prompt) {
  const resp = await fetch("/api/anthropic", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      model: "claude-haiku-4-5-20251001",
      max_tokens: 4000,
      messages: [{ role: "user", content: prompt }],
    }),
  });
  if (!resp.ok) throw new Error(`API error ${resp.status}`);
  const data = await resp.json();
  const text = data.content?.find(b => b.type === "text")?.text || "";
  const f = text.indexOf("{"), l = text.lastIndexOf("}");
  if (f === -1) throw new Error("No JSON in response");
  return JSON.parse(text.slice(f, l + 1));
}

// ── HELPERS ───────────────────────────────────────────────────────────────────
const today = () => new Date().toISOString().split("T")[0];
const inDays = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d.toISOString().split("T")[0]; };
const fmtTime = (t) => t?.includes("T") ? t.split("T")[1].slice(0, 5) : (t || "—");

// ── DEAL BADGE ────────────────────────────────────────────────────────────────
function DealBadge({ score, label }) {
  const c = { best: ["#f0fdf4","#bbf7d0","#15803d"], good: ["#eff6ff","#bfdbfe","#1d4ed8"], fair: ["#fffbeb","#fde68a","#b45309"] }[score] || ["#f8fafc","#e2e8f0","#6b7280"];
  return <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20, background: c[0], border: `1.5px solid ${c[1]}`, color: c[2] }}>{label || score}</span>;
}

// ── BOOKING BUTTONS ───────────────────────────────────────────────────────────
function BookBtn({ name, color, icon, href }) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}
      style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "8px 14px", borderRadius: 8, border: `1.5px solid ${color}33`, background: `${color}0d`, color, fontSize: 12, fontWeight: 700, textDecoration: "none" }}
      onMouseEnter={e => e.currentTarget.style.background = `${color}22`}
      onMouseLeave={e => e.currentTarget.style.background = `${color}0d`}>
      <span style={{ width: 18, height: 18, borderRadius: 4, background: color, color: "#fff", fontSize: 10, fontWeight: 900, display: "flex", alignItems: "center", justifyContent: "center" }}>{icon}</span>
      {name}
    </a>
  );
}

// ── RESULT CARDS ──────────────────────────────────────────────────────────────
function FlightCard({ r, rank, params }) {
  const [open, setOpen] = useState(false);
  const isTop = rank === 0;
  return (
    <div onClick={() => setOpen(o => !o)} style={{ background: "#fff", borderRadius: 14, marginBottom: 10, overflow: "hidden", cursor: "pointer", border: `1.5px solid ${open ? "#2563eb" : isTop ? "#bfdbfe" : "#e5e7eb"}`, boxShadow: isTop ? "0 2px 12px rgba(37,99,235,0.08)" : "0 1px 3px rgba(0,0,0,0.04)" }}>
      {isTop && <div style={{ background: "#eff6ff", borderBottom: "1px solid #bfdbfe", padding: "5px 18px", display: "flex", alignItems: "center", gap: 6 }}><div style={{ width: 6, height: 6, borderRadius: "50%", background: "#2563eb" }} /><span style={{ fontSize: 11, fontWeight: 600, color: "#1d4ed8" }}>Lowest price found</span></div>}
      <div style={{ padding: "16px 18px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16 }}>
          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, flexWrap: "wrap" }}>
              <span style={{ fontSize: 14, fontWeight: 700 }}>{r.airline}</span>
              <span style={{ fontSize: 12, color: "#9ca3af" }}>{r.flight_number}</span>
              <DealBadge score={r.deal_score} label={r.deal_label} />
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 22, fontWeight: 800, letterSpacing: -1 }}>{fmtTime(r.departure_time)}</span>
              <div style={{ flex: 1, textAlign: "center" }}>
                <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 3 }}>{r.duration}</div>
                <div style={{ height: 1, background: "#e5e7eb", position: "relative" }}>
                  <span style={{ position: "absolute", top: -8, left: "50%", transform: "translateX(-50%)", fontSize: 10, color: "#9ca3af", whiteSpace: "nowrap", background: "#fff", padding: "0 4px" }}>
                    {r.stops === 0 ? "nonstop" : `${r.stops} stop${r.stops > 1 ? "s" : ""}`}
                  </span>
                </div>
              </div>
              <span style={{ fontSize: 22, fontWeight: 800, letterSpacing: -1 }}>{fmtTime(r.arrival_time)}</span>
            </div>
          </div>
          <div style={{ textAlign: "right", flexShrink: 0 }}>
            <div style={{ fontSize: 24, fontWeight: 900, letterSpacing: -1 }}>${r.total_price?.toLocaleString()}</div>
            <div style={{ fontSize: 12, color: "#6b7280" }}>${r.price_per_adult?.toLocaleString()} / adult</div>
            <div style={{ fontSize: 11, marginTop: 2, color: r.includes_baggage ? "#16a34a" : "#9ca3af" }}>
              {r.includes_baggage ? "✓ Bags included" : r.baggage_fee ? `+$${r.baggage_fee} bags` : "Carry-on only"}
            </div>
          </div>
        </div>
        {open && (
          <div style={{ marginTop: 14, paddingTop: 14, borderTop: "1px solid #f1f5f9" }}>
            <div style={{ display: "flex", gap: 20, flexWrap: "wrap", marginBottom: 12 }}>
              {[["Aircraft", r.aircraft], ["On-time", `${r.on_time_rate}%`], ["Cabin", r.cabin_class], ["Refundable", r.refundable ? "Yes ✓" : "No"], ...(r.stop_cities?.length ? [["Via", r.stop_cities.join(", ")]] : [])].map(([k, v]) => (
                <div key={k}><div style={{ fontSize: 11, color: "#9ca3af" }}>{k}</div><div style={{ fontSize: 13, fontWeight: 600 }}>{v}</div></div>
              ))}
            </div>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <BookBtn name="Skyscanner" color="#0770e3" icon="S" href={skyscannerFlights(params)} />
              <BookBtn name="Kayak" color="#ff6900" icon="K" href={kayakFlights(params)} />
              <BookBtn name="Expedia" color="#00355f" icon="E" href={expediaFlights(params)} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function HotelCard({ r, rank, params }) {
  const [open, setOpen] = useState(false);
  const isTop = rank === 0;
  return (
    <div onClick={() => setOpen(o => !o)} style={{ background: "#fff", borderRadius: 14, marginBottom: 10, overflow: "hidden", cursor: "pointer", border: `1.5px solid ${open ? "#2563eb" : isTop ? "#bfdbfe" : "#e5e7eb"}`, boxShadow: isTop ? "0 2px 12px rgba(37,99,235,0.08)" : "0 1px 3px rgba(0,0,0,0.04)" }}>
      {isTop && <div style={{ background: "#eff6ff", borderBottom: "1px solid #bfdbfe", padding: "5px 18px", display: "flex", alignItems: "center", gap: 6 }}><div style={{ width: 6, height: 6, borderRadius: "50%", background: "#2563eb" }} /><span style={{ fontSize: 11, fontWeight: 600, color: "#1d4ed8" }}>Best value hotel</span></div>}
      <div style={{ padding: "16px 18px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4, flexWrap: "wrap" }}>
              <span style={{ fontSize: 14, fontWeight: 700 }}>{r.name}</span>
              <span style={{ color: "#f59e0b" }}>{"★".repeat(Math.min(r.stars || 0, 5))}</span>
              <DealBadge score={r.deal_score} label={r.deal_label} />
            </div>
            <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 8 }}>{r.neighborhood} · {r.distance_to_center} from center</div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: 13, fontWeight: 800, color: "#fff", background: "#003580", padding: "2px 8px", borderRadius: 6 }}>{r.rating}</span>
              <span style={{ fontSize: 13, fontWeight: 600 }}>{r.review_label}</span>
              <span style={{ fontSize: 12, color: "#9ca3af" }}>({r.review_count?.toLocaleString()})</span>
            </div>
          </div>
          <div style={{ textAlign: "right", flexShrink: 0 }}>
            <div style={{ fontSize: 24, fontWeight: 900, letterSpacing: -1 }}>${r.total_price?.toLocaleString()}</div>
            <div style={{ fontSize: 12, color: "#6b7280" }}>${r.price_per_night}/night</div>
            <div style={{ fontSize: 11, marginTop: 2, color: r.cancellation?.includes("Free") ? "#16a34a" : "#ef4444" }}>{r.cancellation}</div>
          </div>
        </div>
        {open && (
          <div style={{ marginTop: 14, paddingTop: 14, borderTop: "1px solid #f1f5f9" }}>
            <div style={{ marginBottom: 8 }}><div style={{ fontSize: 11, color: "#9ca3af" }}>Room type</div><div style={{ fontSize: 13, fontWeight: 600 }}>{r.room_type}</div></div>
            {r.highlights?.length > 0 && <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8 }}>{r.highlights.map((h, i) => <span key={i} style={{ fontSize: 12, padding: "2px 10px", background: "#f8fafc", border: "1px solid #e5e7eb", borderRadius: 20 }}>{h}</span>)}</div>}
            {r.amenities?.length > 0 && <div style={{ fontSize: 12, color: "#374151", marginBottom: 12 }}>{r.amenities.slice(0, 6).join(" · ")}</div>}
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <BookBtn name="Google Hotels" color="#4285f4" icon="G" href={googleHotels(params)} />
              <BookBtn name="Booking.com" color="#003580" icon="B" href={bookingCom(params)} />
              <BookBtn name="Expedia" color="#00355f" icon="E" href={expediaHotels(params)} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function CarCard({ r, rank, params }) {
  const [open, setOpen] = useState(false);
  const isTop = rank === 0;
  return (
    <div onClick={() => setOpen(o => !o)} style={{ background: "#fff", borderRadius: 14, marginBottom: 10, overflow: "hidden", cursor: "pointer", border: `1.5px solid ${open ? "#2563eb" : isTop ? "#bfdbfe" : "#e5e7eb"}`, boxShadow: isTop ? "0 2px 12px rgba(37,99,235,0.08)" : "0 1px 3px rgba(0,0,0,0.04)" }}>
      {isTop && <div style={{ background: "#eff6ff", borderBottom: "1px solid #bfdbfe", padding: "5px 18px", display: "flex", alignItems: "center", gap: 6 }}><div style={{ width: 6, height: 6, borderRadius: "50%", background: "#2563eb" }} /><span style={{ fontSize: 11, fontWeight: 600, color: "#1d4ed8" }}>Best price</span></div>}
      <div style={{ padding: "16px 18px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4, flexWrap: "wrap" }}>
              <span style={{ fontSize: 14, fontWeight: 700 }}>{r.company}</span>
              <DealBadge score={r.deal_score} label={r.deal_label} />
            </div>
            <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>{r.car_name}</div>
            <div style={{ display: "flex", gap: 12, fontSize: 12, color: "#6b7280", flexWrap: "wrap" }}>
              <span>🪑 {r.seats} seats</span>
              <span>⚙️ {r.transmission}</span>
              <span>📍 {r.mileage}</span>
              {r.airport_pickup && <span>✈️ Airport pickup</span>}
            </div>
          </div>
          <div style={{ textAlign: "right", flexShrink: 0 }}>
            <div style={{ fontSize: 24, fontWeight: 900, letterSpacing: -1 }}>${r.total_price?.toLocaleString()}</div>
            <div style={{ fontSize: 12, color: "#6b7280" }}>${r.price_per_day}/day</div>
            <div style={{ fontSize: 11, marginTop: 2, color: r.includes_insurance ? "#16a34a" : "#9ca3af" }}>
              {r.includes_insurance ? "✓ Insurance included" : r.insurance_per_day ? `+$${r.insurance_per_day}/day ins.` : ""}
            </div>
          </div>
        </div>
        {open && (
          <div style={{ marginTop: 14, paddingTop: 14, borderTop: "1px solid #f1f5f9" }}>
            <div style={{ display: "flex", gap: 20, flexWrap: "wrap", marginBottom: 12 }}>
              {[["Class", r.car_class], ["Cancellation", r.free_cancellation ? "Free ✓" : "Non-refundable"], ["Rating", `${r.rating}/10`]].map(([k, v]) => (
                <div key={k}><div style={{ fontSize: 11, color: "#9ca3af" }}>{k}</div><div style={{ fontSize: 13, fontWeight: 600 }}>{v}</div></div>
              ))}
            </div>
            {r.features?.length > 0 && <div style={{ fontSize: 12, color: "#374151", marginBottom: 12 }}>{r.features.join(" · ")}</div>}
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <BookBtn name="Kayak" color="#ff6900" icon="K" href={kayakCars(params)} />
              <BookBtn name="Expedia" color="#00355f" icon="E" href={expediaCars(params)} />
              <BookBtn name="Rentalcars" color="#e63946" icon="R" href={rentalcars(params)} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── MAIN COMPONENT ────────────────────────────────────────────────────────────
const TABS = [
  { key: "flights", label: "Flights",     icon: "✈️" },
  { key: "hotels",  label: "Hotels",      icon: "🏨" },
  { key: "cars",    label: "Car Rentals", icon: "🚗" },
];
const CABINS   = ["Economy", "Premium Economy", "Business", "First"];
const CAR_TYPES = ["Any type", "Economy", "Compact", "Midsize", "SUV", "Luxury", "Minivan"];

const inp = { width: "100%", padding: "10px 12px", borderRadius: 10, border: "1.5px solid #e5e7eb", fontSize: 14, outline: "none", boxSizing: "border-box", background: "#fff" };
const lbl = { fontSize: 11, fontWeight: 600, color: "#6b7280", marginBottom: 4, display: "block", textTransform: "uppercase", letterSpacing: 0.5 };
const fld = { display: "flex", flexDirection: "column" };

export default function TravelSearch() {
  const [tab, setTab]         = useState("flights");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError]     = useState(null);
  const [params, setParams]   = useState(null);

  // Flight fields
  const [originCode, setOriginCode]   = useState("");
  const [destCode, setDestCode]       = useState("");
  const [departDate, setDepartDate]   = useState(inDays(14));
  const [returnDate, setReturnDate]   = useState(inDays(21));
  const [tripType, setTripType]       = useState("roundtrip");
  const [adults, setAdults]           = useState(1);
  const [children, setChildren]       = useState(0);
  const [infants, setInfants]         = useState(0);
  const [cabin, setCabin]             = useState("Economy");

  // Hotel fields
  const [hotelDest, setHotelDest]     = useState("");
  const [checkin, setCheckin]         = useState(inDays(14));
  const [checkout, setCheckout]       = useState(inDays(17));
  const [guests, setGuests]           = useState(2);
  const [rooms, setRooms]             = useState(1);
  const [stars, setStars]             = useState("");

  // Car fields
  const [pickup, setPickup]           = useState("");
  const [pickupDate, setPickupDate]   = useState(inDays(14));
  const [dropoffDate, setDropoffDate] = useState(inDays(17));
  const [carType, setCarType]         = useState("Any type");

  const search = async () => {
    setLoading(true); setError(null); setResults(null);
    try {
      let prompt, p;
      if (tab === "flights") {
        if (!originCode) throw new Error("Please select a departure airport");
        if (!destCode)   throw new Error("Please select a destination airport");
        if (adults < 1)  throw new Error("At least 1 adult required");
        p = { origin: originCode, destination: destCode, departDate, returnDate: tripType === "roundtrip" ? returnDate : null, adults, children, infants, cabinClass: cabin };
        prompt = flightPrompt(p);
      } else if (tab === "hotels") {
        if (!hotelDest) throw new Error("Please enter a destination");
        p = { location: hotelDest, checkin, checkout, guests, rooms, starRating: stars };
        prompt = hotelPrompt(p);
      } else {
        if (!pickup) throw new Error("Please enter a pickup location");
        p = { pickupLocation: pickup, pickupDate, dropoffDate, carType: carType === "Any type" ? "" : carType };
        prompt = carPrompt(p);
      }
      setParams(p);
      const data = await callAgent(prompt);
      if (!data.results?.length) throw new Error("No results found. Try different search criteria.");
      setResults(data.results);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 16px 40px", fontFamily: "system-ui, -apple-system, sans-serif" }}>

      {/* Tab Bar */}
      <div style={{ display: "flex", gap: 6, marginBottom: 20, background: "#f8fafc", borderRadius: 12, padding: 4 }}>
        {TABS.map(t => (
          <button key={t.key} onClick={() => { setTab(t.key); setResults(null); setError(null); }} style={{
            flex: 1, padding: "10px 4px", borderRadius: 9, border: "none", cursor: "pointer", fontSize: 13, fontWeight: 600,
            background: tab === t.key ? "#fff" : "transparent", color: tab === t.key ? "#1d4ed8" : "#6b7280",
            boxShadow: tab === t.key ? "0 1px 4px rgba(0,0,0,0.08)" : "none", transition: "all 0.15s",
          }}>{t.icon} {t.label}</button>
        ))}
      </div>

      {/* Form Card */}
      <div style={{ background: "#fff", borderRadius: 16, border: "1.5px solid #e5e7eb", padding: 20, marginBottom: 20, boxShadow: "0 1px 6px rgba(0,0,0,0.04)" }}>

        {/* ── FLIGHTS ── */}
        {tab === "flights" && <>
          <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
            {[["roundtrip","↔ Round trip"],["oneway","→ One way"]].map(([v, label]) => (
              <button key={v} onClick={() => setTripType(v)} style={{ padding: "6px 16px", borderRadius: 20, border: `1.5px solid ${tripType === v ? "#2563eb" : "#e5e7eb"}`, background: tripType === v ? "#eff6ff" : "#fff", color: tripType === v ? "#1d4ed8" : "#6b7280", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>{label}</button>
            ))}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
            <AirportInput label="From" placeholder="City or airport code" onChange={setOriginCode} />
            <AirportInput label="To" placeholder="City or airport code" onChange={setDestCode} />
            <div style={fld}><label style={lbl}>Depart</label><input type="date" value={departDate} min={today()} onChange={e => setDepartDate(e.target.value)} style={inp} /></div>
            {tripType === "roundtrip" && <div style={fld}><label style={lbl}>Return</label><input type="date" value={returnDate} min={departDate} onChange={e => setReturnDate(e.target.value)} style={inp} /></div>}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 10, marginBottom: 4 }}>
            <div style={fld}><label style={lbl}>Adults (12+)</label>
              <select value={adults} onChange={e => setAdults(+e.target.value)} style={inp}>
                {[1,2,3,4,5,6,7,8,9].map(n => <option key={n} value={n}>{n}</option>)}
              </select>
            </div>
            <div style={fld}><label style={lbl}>Children (2-11)</label>
              <select value={children} onChange={e => setChildren(+e.target.value)} style={inp}>
                {[0,1,2,3,4,5].map(n => <option key={n} value={n}>{n}</option>)}
              </select>
            </div>
            <div style={fld}><label style={lbl}>Infants (0-1)</label>
              <select value={infants} onChange={e => setInfants(+e.target.value)} style={inp}>
                {[0,1,2].map(n => <option key={n} value={n}>{n}</option>)}
              </select>
            </div>
            <div style={fld}><label style={lbl}>Cabin</label>
              <select value={cabin} onChange={e => setCabin(e.target.value)} style={inp}>
                {CABINS.map(c => <option key={c}>{c}</option>)}
              </select>
            </div>
          </div>
          {(adults + children + infants) > 1 && (
            <div style={{ fontSize: 12, color: "#6b7280", marginTop: 6 }}>
              Total: {adults} adult{adults > 1 ? "s" : ""}{children > 0 ? `, ${children} child${children > 1 ? "ren" : ""}` : ""}{infants > 0 ? `, ${infants} infant${infants > 1 ? "s" : ""}` : ""} · {adults + children + infants} passengers
            </div>
          )}
        </>}

        {/* ── HOTELS ── */}
        {tab === "hotels" && <>
          <div style={{ ...fld, marginBottom: 12 }}>
            <label style={lbl}>Destination</label>
            <input value={hotelDest} onChange={e => setHotelDest(e.target.value)} placeholder="Chicago, Paris, Tokyo..." style={inp} />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
            <div style={fld}><label style={lbl}>Check-in</label><input type="date" value={checkin} min={today()} onChange={e => setCheckin(e.target.value)} style={inp} /></div>
            <div style={fld}><label style={lbl}>Check-out</label><input type="date" value={checkout} min={checkin} onChange={e => setCheckout(e.target.value)} style={inp} /></div>
            <div style={fld}><label style={lbl}>Guests</label>
              <select value={guests} onChange={e => setGuests(+e.target.value)} style={inp}>
                {[1,2,3,4,5,6].map(n => <option key={n} value={n}>{n} guest{n > 1 ? "s" : ""}</option>)}
              </select>
            </div>
            <div style={fld}><label style={lbl}>Rooms</label>
              <select value={rooms} onChange={e => setRooms(+e.target.value)} style={inp}>
                {[1,2,3,4].map(n => <option key={n} value={n}>{n} room{n > 1 ? "s" : ""}</option>)}
              </select>
            </div>
          </div>
          <div style={fld}><label style={lbl}>Minimum stars</label>
            <select value={stars} onChange={e => setStars(e.target.value)} style={inp}>
              <option value="">Any stars</option>
              {[3,4,5].map(n => <option key={n} value={n}>{n}+ ★</option>)}
            </select>
          </div>
        </>}

        {/* ── CARS ── */}
        {tab === "cars" && <>
          <div style={{ ...fld, marginBottom: 12 }}>
            <label style={lbl}>Pickup location</label>
            <input value={pickup} onChange={e => setPickup(e.target.value)} placeholder="Chicago O'Hare Airport, Downtown Denver..." style={inp} />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
            <div style={fld}><label style={lbl}>Pickup date</label><input type="date" value={pickupDate} min={today()} onChange={e => setPickupDate(e.target.value)} style={inp} /></div>
            <div style={fld}><label style={lbl}>Drop-off date</label><input type="date" value={dropoffDate} min={pickupDate} onChange={e => setDropoffDate(e.target.value)} style={inp} /></div>
          </div>
          <div style={fld}><label style={lbl}>Car type</label>
            <select value={carType} onChange={e => setCarType(e.target.value)} style={inp}>
              {CAR_TYPES.map(t => <option key={t}>{t}</option>)}
            </select>
          </div>
        </>}

        <button onClick={search} disabled={loading} style={{ width: "100%", marginTop: 16, padding: 13, borderRadius: 12, border: "none", background: loading ? "#93c5fd" : "#1d4ed8", color: "#fff", fontSize: 15, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer" }}>
          {loading ? "Searching best prices..." : `Search ${TABS.find(t => t.key === tab)?.label}`}
        </button>
      </div>

      {/* Error */}
      {error && <div style={{ background: "#fef2f2", border: "1.5px solid #fecaca", borderRadius: 12, padding: "14px 18px", marginBottom: 16, color: "#dc2626", fontSize: 14 }}>⚠️ {error}</div>}

      {/* Results */}
      {results?.length > 0 && <>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: "#374151" }}>{results.length} options found</div>
          <div style={{ fontSize: 12, color: "#9ca3af" }}>Click any result to see booking options</div>
        </div>
        {tab === "flights" && results.map((r, i) => <FlightCard key={i} r={r} rank={i} params={params} />)}
        {tab === "hotels"  && results.map((r, i) => <HotelCard  key={i} r={r} rank={i} params={params} />)}
        {tab === "cars"    && results.map((r, i) => <CarCard    key={i} r={r} rank={i} params={params} />)}
        <div style={{ marginTop: 16, padding: "12px 16px", background: "#f8fafc", borderRadius: 10, fontSize: 11, color: "#9ca3af", lineHeight: 1.6 }}>
          💡 Prices are AI-estimated. Click booking links for real-time availability and pricing. MioPrice earns a commission on completed bookings through our links.
        </div>
      </>}

      {results?.length === 0 && <div style={{ textAlign: "center", padding: "40px 20px", color: "#6b7280" }}>No results found. Try adjusting your search.</div>}
    </div>
  );
}
